import createTypes from 'redux-create-action-types';

export default createTypes(
  'GET_USERS',
  'GET_USER',
  'CREATE_NEW_USER',
  'EDIT_USER',
  'DELETE_USER',
);
